import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ComingSoonModal({ open, onClose }) {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const FIXED_PASS = "Investor@@2026"; // 🔐 fixed investor access password

  if (!open) return null;

  const handleLogin = () => {
    if (password === FIXED_PASS) {
      localStorage.setItem("investorAccess", "true");
      if (onClose) onClose();
      navigate("/productzones");
    } else {
      setError("❌ Incorrect password. Please try again.");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-neutral-900 border border-yellow-600 rounded-2xl shadow-xl p-8 max-w-md w-full relative">
        <h2 className="text-2xl font-bold text-yellow-300 mb-3 text-center">
          🚧 Coming Soon Access
        </h2>

        <p className="text-gray-200 text-center text-sm mb-3">
          Million2Trillion Live Market Tools are in pre-release mode.
          <br />
          Authorized investors can log in to preview the platform.
        </p>

        {/* Investor Password Input */}
        <div className="mt-6">
          <label className="block text-sm text-gray-300 mb-2">
            Investor Access Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyPress}
            className="w-full bg-white text-black border border-slate-400 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-500 placeholder-gray-500"
            placeholder="💡 Type the investor password to access Product Zone"
          />
          {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-3 mt-6">
          <button
            onClick={handleLogin}
            className="bg-green-500 hover:bg-green-600 text-black font-semibold py-2 rounded-lg transition"
          >
            Access Product Zone
          </button>

          <button
            onClick={() => navigate("/waitlist")}
            className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-2 rounded-lg transition"
          >
            Join Waitlist
          </button>

          <button
            onClick={() => navigate("/")}
            className="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-2 rounded-lg transition border border-gray-600"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
